import { render, staticRenderFns } from "./AddOn.vue?vue&type=template&id=5d1d0682&scoped=true&"
import script from "./AddOn.vue?vue&type=script&lang=js&"
export * from "./AddOn.vue?vue&type=script&lang=js&"
import style0 from "./AddOn.vue?vue&type=style&index=0&id=5d1d0682&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d0682",
  null
  
)

export default component.exports